import React from "react";

export default function Header() {
    //a header with a ALS logo, title, and a sign out button on the right with a bottom border. full width of page
    return (
        <header>
            <img src="/alsLogo.png" alt="ALS Logo"/>
            <h1>ALS-RAC</h1>
        </header>
    )
}